document.addEventListener("DOMContentLoaded", function () {

  let trackSwiper = new Swiper(".mn__wp_swiper.swiper", {
    slidesPerView: 3,pagination: { el: ".swiper-pagination", clickable: true },
    breakpoints: {
      1440: { slidesPerView: 3,spaceBetween: 60 },
      1024: { slidesPerView: 2,spaceBetween: 60 },
      749: { slidesPerView: 1.3,spaceBetween: 15 },
      0:{ slidesPerView: 1.3,spaceBetween: 15 } 
    }
  });
  
  let ReviewsSwiper = new Swiper(".slide__swipermint.swiper", {
    slidesPerView: 3, pagination: { el: ".swiper-pagination", clickable: true },
    breakpoints: {
      1440: { slidesPerView: 3,spaceBetween: 60 },
      1024: { slidesPerView: 2,spaceBetween: 60 },
      749: { slidesPerView: 1.01,spaceBetween: 15 },
      0:{ slidesPerView: 1.01,spaceBetween: 15 } 
    }
  }); 

  let tableSwiper = new Swiper(".swiper.BothBox__swipeSlide", {
    slidesPerView: 2,loop:true,pagination: { el: ".swiper-pagination", clickable: true },
    breakpoints: {
      1440: { slidesPerView: 2,spaceBetween: 31 },
      1365: { slidesPerView: 1,spaceBetween: 8 },
      0: { slidesPerView: 1,spaceBetween: 8 }
    }    
  }); 

  let ProgressSwiper = new Swiper(".MainSwiper__sliderAssets.swiper", {
    slidesPerView: 3, pagination: { el: ".swiper-pagination", clickable: true },
    breakpoints: {
      1440: { slidesPerView: 3,spaceBetween: 60 },
      1280: { slidesPerView: 2,spaceBetween: 60 },
      898: { slidesPerView: 1.01,spaceBetween: 15 },
      0:{ slidesPerView: 1.01,spaceBetween: 15 } 
    }
  }); 

  let MobileImageSwiper = new Swiper(".Main__swiperCrenInterior.swiper", {
    slidesPerView: 3, pagination: { el: ".swiper-pagination", clickable: true },navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
    breakpoints: {
      1440: { slidesPerView: 3,spaceBetween: 60 },
      1280: { slidesPerView: 2,spaceBetween: 60 },
      898: { slidesPerView: 1,spaceBetween: 15 },
      0:{ slidesPerView: 1,spaceBetween: 15 } 
    }
  }); 

  let ThumbnailSwiper__ab = new Swiper(".Mainthumb__swiperxt.swiper", {
    slidesPerView: 4.5,
    spaceBetween: 16,
    centeredSlides: false,
    watchSlidesProgress: true
  });  
  
  let MainmgSwiper__ab = new Swiper(".swiper__slidermainWp.swiper", {
    thumbs: { swiper: ThumbnailSwiper__ab},navigation: {nextEl: ".swiper-button-next",prevEl: ".swiper-button-prev" },      
    breakpoints: {
      1440: { slidesPerView: 1 },
      1024: { slidesPerView: 1 },
      749: { slidesPerView: 1.1,spaceBetween: 10 },
      0:{ slidesPerView: 1.1,spaceBetween: 10 } 
    }
  });   

  let videowsSwiper = new Swiper(".mn__swiperVideothumbnail.swiper", {
    slidesPerView: 3, pagination: { el: ".swiper-pagination", clickable: true },
    breakpoints: {
      1440: { slidesPerView: 3,spaceBetween: 60 },
      1024: { slidesPerView: 2,spaceBetween: 60 },
      749: { slidesPerView: 1.2,spaceBetween: 15 },
      430: { slidesPerView: 1.495,spaceBetween: 15 },
      375: { slidesPerView: 1.47,spaceBetween: 15 },
      0:{ slidesPerView: 1.2,spaceBetween: 15 } 
    }
  });   

  document.querySelectorAll('.pause-image, .main-video').forEach(function(element) {
      element.addEventListener('click', function() {
          let videoBox = this.closest('.video-box');
          let clickedVideo = videoBox.querySelector('.main-video');
          let pauseImage = videoBox.querySelector('.pause-image');
  
          document.querySelectorAll('.main-video').forEach(function(video) {
            if (video !== clickedVideo) {
              video.pause();
              let otherPauseImage = video.closest('.video-box').querySelector('.pause-image');
              if (otherPauseImage) {
                otherPauseImage.style.display = 'block';
              }
            }
          });
  
          if (clickedVideo.paused) {
              clickedVideo.play();
              pauseImage.style.display = 'none';
          } else {
              clickedVideo.pause();
              pauseImage.style.display = 'block';
          }
      });
  });
  
  document.querySelectorAll('.main-video').forEach(function(video) {
      video.addEventListener('ended', function() {
          let pauseImage = this.closest('.video-box').querySelector('.pause-image');
          if (pauseImage) {
              pauseImage.style.display = 'block';
          }
      });
  });

  document.querySelectorAll('[js-scroll-pdpview]').forEach((event)=>{
    event.addEventListener('click', (target)=>{
      target.preventDefault();
      document.getElementById('custom-main-product').scrollIntoView({ behavior: 'smooth' });
    })
  })

  document.querySelectorAll('.faq-item').forEach(item => {
      item.addEventListener('click', (event) => {
          event.stopPropagation();
          const faqAnswer = item.querySelector('.faq-answer');
          const isActive = item.classList.contains('active');
          document.querySelectorAll('.faq-item').forEach(el => {
              el.classList.remove('active');
              el.querySelector('.faq-answer').style.maxHeight = null;
          });
          if (!isActive) {
              item.classList.add('active');
              faqAnswer.style.maxHeight = faqAnswer.scrollHeight + "px";
          } else {
              item.classList.remove('active');
              faqAnswer.style.maxHeight = null;
          }
      });
  });  

  document.querySelectorAll(".both-warranty-boxes").forEach((box) => {
      box.addEventListener("click", function (event) {
          const clickedImage = event.target.closest(".warranty-image");
          if (!clickedImage) return;
          box.querySelectorAll(".warranty-image").forEach(img => img.classList.remove("active"));
          clickedImage.classList.add("active");
          let pdpId = clickedImage.getAttribute("pdp-id");
          let price = clickedImage.getAttribute("data-price");
          let cutPrice = clickedImage.getAttribute("data-cut-price");
          if (pdpId) {
              document.querySelectorAll(".custom-pdp-btn").forEach(btn => {
                  btn.setAttribute("data-variant-id", pdpId);
              });
          }
          if (price) {
              document.querySelectorAll(".normal-price").forEach(priceElement => {
                  priceElement.innerHTML = price;
              });
          }
          if (cutPrice) {
              document.querySelectorAll(".btn-cut-price, .compare-price").forEach(cutPriceElement => {
                  cutPriceElement.innerHTML = cutPrice;
              });
          }
      });
      setTimeout(() => {
          let secondImage = box.querySelectorAll(".warranty-image")[0];
          if (secondImage) secondImage.click();
      }, 100);
  });  

  document.querySelectorAll(".custom-pdp-btn").forEach((btn) => {
      btn.addEventListener("click", function () {
          let variantId = this.getAttribute("data-variant-id");
          if (variantId) {
              window.location.href = `/cart/${variantId}:1`;
          }
      });
  });  

  let popup = document.getElementById("hsa-fsa-popup");
  let closeBtn = document.querySelector(".close-popup");
  let learnMoreBtn = document.querySelector(".learn-more");
  function openPopup() {
      popup.style.visibility = "visible";
      popup.style.opacity = "1";
      document.body.style.overflow = "hidden";
  }
  function closePopup() {
      popup.style.visibility = "hidden";
      popup.style.opacity = "0";
      document.body.style.overflow = "";
  }
  if (learnMoreBtn) {
      learnMoreBtn.addEventListener("click", openPopup);
  }
  if (closeBtn) {
      closeBtn.addEventListener("click", closePopup);
  }
  popup.addEventListener("click", function (event) {
      if (event.target === popup) {
          closePopup();
      }
  });  
   
})